import { render, staticRenderFns } from "./GoFeedback.vue?vue&type=template&id=24ab9d00&scoped=true"
import script from "./GoFeedback.vue?vue&type=script&lang=js"
export * from "./GoFeedback.vue?vue&type=script&lang=js"
import style0 from "./GoFeedback.vue?vue&type=style&index=0&id=24ab9d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab9d00",
  null
  
)

export default component.exports